import React, { useEffect } from 'react'
import { LoginManager } from '../../core/login-manager';
import { Button, Container, Row, Col } from 'react-bootstrap'

function IC_Question( { data, dataId, setDataKeyValue } ) {

    console.log("IC_Question", LoginManager.getUserInfo())
    if( LoginManager.getUserInfo()?.id > 1){
        return 
    }

   const exemples = {
  // 1) VIDEO
  "video" :{
    type: "video",
    url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
  },

  // 2) BOOLEAN
  "boolean" :{
    inputType: "boolean",
    label: "Porta blindata",
    defaultValue: false,
  },

  // 3) NUMBER
  "number" :{
    inputType: "number",
    defaultValue: 0,
    min: 1,
    max: { "3.monolocale": 6, "3.bilocale": 8, "3.trilocale": 12 }
  },

  // 4) SELECT (singolo)
  "select" :{
    inputType: "select",
    defaultValue: "monolocale",
    options: [
      { value: "monolocale", label: "Monolocale - €19.900+ IVA", unitPrice: "19900", position: 1 },
      { value: "bilocale", label: "Bilocale - €29.900+ IVA", unitPrice: "29900", position: 2 },
      { value: "trilocale", label: "Trilocale - €49.900 + IVA", unitPrice: "49900", position: 3 }
    ]
  },

  // 4b) SELECT (multiple)
  "select_multi" :{
    inputType: "select_multiple",
    multiple: true,
    defaultValue: ["box_doccia", "scaldasalviette_elettrico"],
    options: [
      { value: "scaldasalviette_elettrico", label: "Scaldasalviette elettrico", unitPrice: "0", position: 1 },
      { value: "box_doccia", label: "Box doccia", unitPrice: "0", position: 2 },
      { value: "scaldabagno_elettrico", label: "Scaldabagno elettrico", unitPrice: "0", position: 3 }
    ]
  },

  // 5) TEXT
  "text" :{
    inputType: "text",
    placeholder: "Via Roma 11 - Roma (RM) 31000",
    defaultValue: "Via Roma 11 - Roma (RM) 31000"
  }
};


   function setExemple(type){
    if(exemples[type]){
        setDataKeyValue('definition', JSON.stringify(exemples[type] , null, 2))
    }
   }

  return (
    <>
        <Container fluid className='m-0 p-0'>
            <Row className='m-0 p-0'>
                <Col className='m-0 p-0 d-flex gap-2 mb-4'>
                    Exemples: 
                    <Button variant="primary" size="sm" onClick={() => setExemple('text')}>Text</Button>
                    <Button variant="primary" size="sm" onClick={() => setExemple('number')}>Number</Button>
                    <Button variant="primary" size="sm" onClick={() => setExemple('boolean')}>Boolean</Button>
                    <Button variant="primary" size="sm" onClick={() => setExemple('select')}>Select Single</Button>
                    {/* <Button variant="primary" size="sm" onClick={() => setExemple('select_multiple')}>Select Multiple</Button> */}
                    <Button variant="primary" size="sm" onClick={() => setExemple('video')}>Video</Button>
                </Col>
            </Row>
        </Container>
    </>
  )
}

export default IC_Question